import React from 'react';
import Logo from '../assets/dwj.png';
import { Instagram, Facebook, Linkedin, Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#4A4238] text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3
              className="text-3xl font-semibold mb-4"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              <img src={Logo} alt="DesignJoy logo" />
            </h3>
            <p className="text-white/80 leading-relaxed">
              Creating beautiful, functional spaces that bring joy to everyday living.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/80 hover:text-[#D4A574] transition-colors duration-300"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/80 hover:text-[#D4A574] transition-colors duration-300"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('gallery').scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/80 hover:text-[#D4A574] transition-colors duration-300"
                >
                  Gallery
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/80 hover:text-[#D4A574] transition-colors duration-300"
                >
                  Contact
                </button>
              </li>
              <li>
                <a
                  href="/privacy.html"
                  className="text-white/80 hover:text-[#D4A574] transition-colors duration-300"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="/terms.html"
                  className="text-white/80 hover:text-[#D4A574] transition-colors duration-300"
                >
                  Terms of Use
                </a>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h4 className="text-xl font-semibold mb-4">Follow Us</h4>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/designswithjoy7/"
                className="bg-white/10 p-3 rounded-full hover:bg-[#D4A574] transition-all duration-300 hover:scale-110"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="bg-white/10 p-3 rounded-full hover:bg-[#D4A574] transition-all duration-300 hover:scale-110"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="#"
                className="bg-white/10 p-3 rounded-full hover:bg-[#D4A574] transition-all duration-300 hover:scale-110"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/70 text-sm">
              © 2025 Designs with Joy. All rights reserved.
            </p>
            <p className="text-white/70 text-sm">
              <a href="/privacy.html" className="hover:text-[#D4A574]">Privacy Policy</a> · <a href="/terms.html" className="hover:text-[#D4A574]">Terms</a>
            </p>
            <p className="text-white/70 text-sm flex items-center gap-1">
              Made with <Heart className="h-4 w-4 text-[#D4A574] fill-current" /> for beautiful spaces
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;